import script from "./Qna.vue?vue&type=script&setup=true&lang=js"
export * from "./Qna.vue?vue&type=script&setup=true&lang=js"

import "./Qna.vue?vue&type=style&index=0&id=59515db6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59515db6"]])

export default __exports__